import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { BodyText } from '@unmind/design-system-components-web';
import RoutePath from '../../../App/RoutePath';
import GenericExploreContent from '../../../Explore/GenericExploreContent/GenericExploreContent';
import { SectionHeadingTitle } from '../styles';
import { PersonalisedTodayContent_user_coursesInProgress } from '../__generated__/PersonalisedTodayContent';

const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: top;
`;

const ArrowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
`;

const StyledLink = styled(Link)`
  display: flex;
  width: 100%;
  height: inherit;
  align-items: center;
  justify-content: center;
  background-color: inherit;
  text-decoration: none;
  &:active {
    opacity: 0.5;
  }
`;

const YourCoursesContainer = styled.section``;

const StyledText = styled(BodyText).attrs(({ theme }) => ({
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize16],
  weight: theme.typography.fontWeights.medium,
}))``;

export interface YourCoursesProps {
  courses: PersonalisedTodayContent_user_coursesInProgress[];
  assetToken?: string | null;
}

const YourCourses = ({ courses, assetToken }: YourCoursesProps) => {
  const { t: translate } = useTranslation('homepage');

  const viewAll = courses.length > 3;

  return courses.length ? (
    <YourCoursesContainer>
      <HeadingWrapper>
        <SectionHeadingTitle>
          {translate('your_courses_section.title')}
        </SectionHeadingTitle>
        <ArrowWrapper>
          {viewAll ? (
            <StyledLink
              to={RoutePath.YourCourses}
              aria-label={translate(
                'your_courses_section.arrow_link_button.text',
              )}
            >
              <StyledText>
                {translate('your_courses_section.arrow_link_button.text')}
              </StyledText>
            </StyledLink>
          ) : null}
        </ArrowWrapper>
      </HeadingWrapper>
      <GenericExploreContent
        content={courses}
        assetToken={assetToken}
        source="explore-your-courses"
      />
    </YourCoursesContainer>
  ) : null;
};

export default YourCourses;
